/* eslint-disable react/react-in-jsx-scope */
import { Outlet, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsLoggedIn } from 'core/selectors';

export const PrivateRoutes = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};
